import { Component, input, output, HostAttributeToken, inject } from '@angular/core';
import { PaginationControlsDirective } from "ngx-pagination";

@Component({
    selector: 'pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: false
})
export class PaginationComponent {
  id = inject(new HostAttributeToken('id'));

  readonly limit = input<number>(15);

  readonly itemsName = input<string>('items');

  readonly pageChange = output<number>();

  readonly limitChange = output<number>();

  getCurrentPageInfo(p: PaginationControlsDirective) {
    return `${p.isFirstPage() ? 1 : ((p.getCurrent() - 1) * this.limit() + 1)}-${p.isLastPage() ? p.getTotalItems() : (p.getCurrent() * this.limit())} of ${p.getTotalItems()} ${this.itemsName()}`;
  }

  onLimitChange(limitSelect: HTMLSelectElement) {
    this.limitChange.emit(Number(limitSelect.value))
  }
}
